import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { validationsList_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {configSidebar_template} from "../components/templates/configSidebar_template";
import * as classicEditor from "@ckeditor/ckeditor5-build-classic";

declare var ko: any;
declare var page: any;

export class config_sidebar extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected configSidebar: configSidebar_template;
    protected validationsList: validationsList_template;
    protected listingPageIdElement: string = 'filterListingPageTemplate';
    protected _isLeavePageWarningNeeded: boolean = true;
    private pollXhr: XMLHttpRequestHandler;
    protected textAreaEditor;
    protected CKEDITOR_CONFIG = {
        toolbar: ["bold", "|", "italic", "link"],
    };

    protected getModuleName(){
        return "config_sidebar";
    }

    buildContent() : Array<Element>{

        this.configSidebar = new configSidebar_template( "configSidebar", this.viewModel, this );
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Config Sidebar");

        return [ this.configSidebar.build()];
    }

    public fillPage() : void{

        this.getPinnedPoll();
    }

    protected getConfigSettings(){

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/config/sidebar/get/";
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetConfigSettingsReturn;
        this.XHRHdl.execute();
    }
    protected onGetConfigSettingsReturn(req,obj){
        return function(){
            obj.manageResponse(req, obj, function() {
                let responseParsed = JSON.parse(req.request.response);

                if (responseParsed.sidebar_general) {

                    let generalConfig = JSON.parse(responseParsed.sidebar_general.value)
                    obj.configSidebar.isPopularSectionEnabledOnHomePage(generalConfig.isPopularSectionEnabledOnHomePage);
                    obj.configSidebar.isPopularSectionEnabledOnArticlePage(generalConfig.isPopularSectionEnabledOnArticlePage);
                    obj.configSidebar.isTrendingNowWithTagInteractionOnArticlePage(generalConfig.isTrendingNowWithTagInteractionOnArticlePage);
                    obj.configSidebar.isPopularSectionEnabledOnListingPage(generalConfig.isPopularSectionEnabledOnListingPage);
                    obj.configSidebar.isTrendingNowSectionEnabledOnHomePage(generalConfig.isTrendingNowSectionEnabledOnHomePage);
                    obj.configSidebar.isTrendingNowSectionEnabledOnArticlePage(generalConfig.isTrendingNowSectionEnabledOnArticlePage);
                    obj.configSidebar.isTrendingNowSectionEnabledOnListingPage(generalConfig.isTrendingNowSectionEnabledOnListingPage);
                }

                if (responseParsed.sidebar_pinned_listing_page) {

                    let pinnedLpConfig = JSON.parse(responseParsed.sidebar_pinned_listing_page.value)
                    obj.configSidebar.isPinnedListingPageEnabledOnHomePage(pinnedLpConfig.isEnabledOnHomePage);
                    obj.configSidebar.isPinnedListingPageEnabledOnArticlePage(pinnedLpConfig.isEnabledOnArticlePage);
                    obj.configSidebar.isPinnedListingPageEnabledOnListingPage(pinnedLpConfig.isEnabledOnListingPage);
                }

                if (responseParsed.sidebar_pinned_poll) {

                    let pinnedPollConfig = JSON.parse(responseParsed.sidebar_pinned_poll.value)
                    obj.configSidebar.isPinnedPollEnabledOnHomePage(pinnedPollConfig.isEnabledOnHomePage);
                    obj.configSidebar.isPinnedPollEnabledOnArticlePage(pinnedPollConfig.isEnabledOnArticlePage);
                    obj.configSidebar.isPinnedPollEnabledOnListingPage(pinnedPollConfig.isEnabledOnListingPage);
                }

                obj.configSidebar.setPermissions(responseParsed.permissions);
                obj.initCkEditor();
                obj.loadingOut(obj.configSidebar.builtTemplate);
            })
        }
    }
    protected getPinnedPoll(){

        this.loadingIn(this.configSidebar.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/config/sidebar/pinned-poll/get/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetPinnedPollReturn;
        this.XHRHdl.execute();
    }

    protected onGetPinnedPollReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function() {
                let responseParsed = JSON.parse(req.request.response);

                obj.configSidebar.setPinnedPoll(responseParsed.pinnedPoll);
                obj.configSidebar.setPinnedPollOptions(responseParsed.polls);
                if (responseParsed.config && responseParsed.config.value) {
                    let configValue = JSON.parse(responseParsed.config.value);
                    obj.configSidebar.isPinnedPollEnabledOnHomePage(configValue.isEnabledOnHomePage);
                    obj.configSidebar.isPinnedPollEnabledOnArticlePage(configValue.isEnabledOnArticlePage);
                    obj.configSidebar.isPinnedPollEnabledOnListingPage(configValue.isEnabledOnListingPage);
                }

                obj.getPinnedListingPages();

            })
        }
    }

    public triggerNotification(message: string): void {
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, message);
        this.getVnAppZone().showNotificationToModule();
    }

    public cancelForm() {
        this.cancelPinnedPageConfig();
        this.pinPollCancel();
        page.redirect(this.getVnAppZone().app.getLastRoute());
    }

    protected cancelPinnedPageConfig() {

        this.getPinnedListingPages();

        this.triggerNotification("Pinned Hub Pages Cancelled!");
    }

    public getPinnedListingPages(): void {

        if(this.XHRHdl){
            this.XHRHdl.cancelAndReset();
        }

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand  + "/config/listing-pages/sidebar/pinned/get/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetPinnedListingPagesReturn;
        this.XHRHdl.execute();
    }

    protected onGetPinnedListingPagesReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);

                if (response) {

                    obj.configSidebar.setPinnedListingPages(response);
                    if (response.length == 0) {
                        obj.getPinnedCustomPages();
                    }
                }
                obj.getConfigSettings();
            });
        }
    }

    protected saveGeneralConfig(){

        this.loadingIn(this.configSidebar.builtTemplate);
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + "/config/sidebar/save/";
        let formReq_params: Array<Array<string>> = [];
        let subViewModel = this.configSidebar.getGeneralConfigViewModel();

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url,formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function(req, obj){

            return function() {

                obj.manageResponse(req, obj, function(){
                    obj.getPinnedPoll();
                    let responseParsed = JSON.parse(req.request.response);

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Sidebar Config saved successfully!");
                    obj.getVnAppZone().showNotificationToModule();

                })
            }
        });
        XHRHdl.execute();
    }

    protected savePinnedPoll(){

        this.loadingIn(this.configSidebar.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + "/config/sidebar/pinned-poll/save/";

        let formReq_params: Array<Array<string>> = [];

        let subViewModel = this.configSidebar.getPinnedPollViewModel();

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url,formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function(req, obj){

            return function() {

                obj.manageResponse(req, obj, function(){
                    obj.getPinnedPoll();
                    let responseParsed = JSON.parse(req.request.response);

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Pinned Poll saved successfully !");
                    obj.getVnAppZone().showNotificationToModule();

                })
            }
        });
        XHRHdl.execute();



    }

    protected savePinnedPageConfig() {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        this.configSidebar.activateLoading();

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + "/config/listing-pages/sidebar/pinned/save/";

        let formReq_params: Array<Array<string>> = [];


        formReq_params.push(["data", ko.toJSON(this.configSidebar.getListingPagesConfigViewModel())]);

        this.XHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    obj.getPinnedListingPages();
                    //let responseParsed = JSON.parse(req.request.response);

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Sidebar Config saved successfully !");
                    obj.getVnAppZone().showNotificationToModule();

                })
                // LOADING : ends
                obj.configSidebar.deactivateLoading();
            }
        });
        this.XHRHdl.execute();


    }

    protected pinPollCancel () {

        this.getPinnedPoll();
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Pinned Poll Cancelled!");
        this.getVnAppZone().showNotificationToModule();
    }

    protected getArticlesSuggestion(keyword, idElement) {

        let subViewModel = {list: {keyword: keyword}, idElement: idElement};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/article/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetArticlesSuggestionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetArticlesSuggestionsReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if (req.request.status == 200) {
                    if (responseParsed.data.articles) {
                        let x = responseParsed.data.idElement;

                        obj.configSidebar.setFilterAutocomplete(responseParsed.data.idElement, responseParsed.data.articles);
                    }
                } else if (req.request.status == "423") {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                } else {
                    obj.configSidebar.onUpdateError(req.request.status, responseParsed);
                }

                // LOADING : ends
                obj.configSidebar.deactivateLoading();
            }
        }
    }

    protected filterSimpleOnChange(idElement) {

        /*console.log(idElement);
        switch (idElement) {
            case 'filterListingPageTemplate':
            case 'filterSowMoreListingPageTemplate':
                break;
            default:
                this.configSidebar.setPinnedArticle(idElement);
        }*/

    }

    public getListingPageIdElement(): string {

        return this.listingPageIdElement;
    }

    public setListingPageIdElement(idElement: string): void {
        this.listingPageIdElement = idElement;
    }

    public getListingPagesSuggestion(keyword, idElement): void {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        this.setListingPageIdElement(idElement);


        let subViewModel = {pagination: {itemPerPage: 25}, filter: {keyword: keyword}, idElement: idElement};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/config/listing-pages/search/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetListingPagesSuggestionReturn;
        this.XHRHdl.execute();
    }

    protected onGetListingPagesSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);

                if (response.data.listingPages) {

                    obj.configSidebar.setFilterListingPagesAutoComplete(response.data.listingPages, obj.getListingPageIdElement());
                }
            });
        }
    }

    public searchPoll(keyword: string) {
        if(keyword.length < 3) return;

        if(this.pollXhr){
            this.pollXhr.cancelAndReset();
        }
        const idBrand = this.getVnAppZone().app.params.idBrand;
        const url = `/api/brand/${idBrand}/polls/search/`;
        let params = [];
        params.push(["keyword", keyword]);
        this.pollXhr = new XMLHttpRequestHandler(url, params, this);
        this.pollXhr.mode = XMLHttpRequestHandler_requestType.POST;
        this.pollXhr.onReadyStateFunction = (req, obj) => {
            return () => {
                obj.manageResponse(req, obj, function () {
                    if (req.request.readyState == 4 && req.request.status == 200) {
                        const response = JSON.parse(req.request.response);
                        obj.configSidebar.setPinnedPollOptions(response);
                    }else{
                        console.error(req.request.response);
                        return [];
                    }
                });
            };
        };
        this.pollXhr.execute();
    }

    protected initCkEditor() {

        if (this.textAreaEditor) {
            return;
        }

        const textArea = document.getElementById("customCardDescription");
        if (!textArea) {
            return;
        }
    
        this.makeEditor(textArea).then((newEditor) => {
            this.textAreaEditor = newEditor;
        });
    }

    protected makeEditor(textArea: HTMLElement): Promise<any> {
        return classicEditor
            .create(textArea, this.CKEDITOR_CONFIG)
            .catch((error) => {
            console.error(error);
            });
    }

    public getPinnedCustomPages(): void {

        if(this.XHRHdl){
            this.XHRHdl.cancelAndReset();
        }

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand  + "/config/listing-pages/sidebar/pinned/custom-pages/get/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetPinnedCustomPagesReturn;
        this.XHRHdl.execute();
    }
    
    protected onGetPinnedCustomPagesReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);

                if (response) {

                    obj.configSidebar.setPinnedCustomPages(response);
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/config_sidebar.ts